import FAQ2 from "../components/FAQ2";
import Footer from "../components/Footer";
import Header from "../components/Header";

function AirportTransfer() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog12.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            JFK Airport Limo Service NYC
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Airport Transfer</span>
          </div>
        </div>
      </div>
    </section>

       <section className="bg-white py-10 sm:py-10 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Limo Service NYC Luxury Limousine & Car Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Limo Service NYC – Luxury Limousine & Car Service by Majestic Voyague NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          If you're searching for a premium limo service in NYC, look no further than MajesticVUSA. 
          We specialize in providing luxury limousine and car services in New York City, offering 
          unmatched comfort, professionalism, and convenience.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Whether you need a chauffeur service in NYC, an executive car, or a stretch limo rental, 
          our team and fleet are ready to make your ride extraordinary.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why Choose Majestic Voyague  Limo Service in NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          At MajesticVUSA, we know that every trip is unique. That's why our New York limo service is 
          fully customized to your schedule and preferences. From the moment you book to your final 
          destination, you'll experience world-class service and attention to detail.
        </p>
        
        <p className="mb-2 sm:mb-2 leading-relaxed font-semibold text-gray-900">
          Key Benefits of Choosing MajesticVUSA:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury Fleet:</strong> Sedans, SUVs, stretch limousines, and executive vans for every occasion.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Professional Chauffeurs:</strong> Experienced, courteous, and punctual drivers.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>24/7 Availability:</strong> Book your NYC limo service anytime, day or night.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Competitive Rates:</strong> Premium NYC limousine service without breaking the bank.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Safety & Cleanliness:</strong> Sanitized vehicles and licensed, insured chauffeurs.</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          From corporate limo services in NYC to party limos for special celebrations, Majestic Voyague NYC
          ensures every ride is exceptional.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Why Choose MajesticVUSA Limo Service NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Airport Limo Service in NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Airport Limo Service in NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Traveling to or from an airport? MajesticVUSA offers airport limo service in NYC to guarantee 
          a timely and stress-free ride. We cover all major airports:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>JFK Airport:</strong> Enjoy a smooth, luxurious pickup after a long flight.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>LaGuardia (LGA) Airport:</strong> Reliable transfers for domestic and business travelers.</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Newark (EWR) Airport:</strong> Seamless rides between NYC and New Jersey.</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our chauffeur service in NYC includes flight tracking, meet-and-greet service, luggage 
          assistance, and complimentary waiting time. With MajesticVUSA, your journey is hassle-free.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Corporate Limo & Executive Car Service NYC
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Impress clients and travel in comfort with MajesticVUSA executive car service in New York 
          City. We provide discreet, punctual, and professional transportation for business meetings, 
          conferences, and VIP guests.
        </p>
        
        <p className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-semibold text-gray-900">
          Corporate Clients Love:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2 text-black">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Hourly or full-day bookings</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Wi-Fi-enabled vehicles</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Bottled water and phone chargers</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Chauffeurs trained for corporate etiquette</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Make every business trip more productive with Majestic Voyague NYC car service that reflects 
          your professionalism.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Corporate Limo & Executive Car Service NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Special Event & Party Limo Service New York" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Special Event & Party Limo Service New York
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Make your special occasions unforgettable with MajesticVUSA luxury limo service in NYC. 
          From weddings to proms and birthday parties, our limousines add elegance and fun to any 
          celebration.
        </p>
        
        <p className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed font-semibold text-gray-900">
          Popular Event Options:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Wedding Limo NYC:</strong> Elegant cars to make your big day unforgettable</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Prom Limo NYC:</strong> Safe, stylish, and memorable rides for students</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Birthday & Anniversary Limos:</strong> Celebrate in luxury</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Party Limo Rental NYC:</strong> Perfect for nightlife, clubs, or group outings</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our professional chauffeurs ensure every ride is smooth, safe, and unforgettable.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Hourly & Long-Distance Limo Rentals
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Looking for flexible transportation? Majestic Voyague offers hourly limo rental in NYC for 
          sightseeing, meetings, or personal trips.
        </p>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          We also provide long-distance rides to Connecticut, New Jersey, and Pennsylvania — all in 
          style, comfort, and safety.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Hourly & Long-Distance Limo Rentals NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Luxury Transportation NYC Fleet Overview" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Luxury Transportation NYC – Fleet Overview
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Our luxury fleet is designed to meet every need and group size:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Sedans & SUVs:</strong> Ideal for airport and business travel</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Stretch Limousines:</strong> Perfect for weddings and parties</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Luxury Vans & Sprinters:</strong> Comfortable group travel</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Black Car Service NYC:</strong> Executive-level service for VIP clients</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Each vehicle is well-maintained, insured, and fully equipped for a first-class experience.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Service Areas
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          MajesticVUSA limo service in NYC proudly serves all five boroughs and nearby regions:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Manhattan</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Brooklyn</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Queens</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Bronx</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Staten Island</strong></span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span><strong>Plus Long Island, New Jersey, and Westchester</strong></span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          No matter where you are, MajesticVUSA is just a call away.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="MajesticVUSA Service Areas NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Why MajesticVUSA Best Limo Service NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Why MajesticVUSA?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          We're more than just a car service in NYC — we're a brand built on trust, punctuality, and 
          exceptional customer experience. Thousands of satisfied clients rely on MajesticVUSA for:
        </p>
        
        <ul className="text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed space-y-2">
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Transparent, competitive pricing</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Courteous, professional chauffeurs</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>Easy online booking</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">●</span>
            <span>24/7 customer support</span>
          </li>
        </ul>
        
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          When you think "best limo service in NYC", think Majestic Voyague where luxury meets reliability.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
    
    <FAQ2/>

    <Footer/>
    </>
  );
}

export default AirportTransfer;
